/* global femcare, Swiper */

femcare.product.banner = {
    $banner: $('.product-main-banner--top'),

    init: function () {
        if (this.$banner.length) {
            this.initSlider();
            this.repositionPowerReviewRating();
        }
    },

    initSlider: function () {
        new Swiper(this.$banner[0], {
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false
            },
        });
    },

    repositionPowerReviewRating: function () {
        var $productRating = $('.product-main__rating');
        $productRating.css('top', '135px');
    }
}
